<template>
  <div 
    v-if="totalReviews" 
    itemprop="aggregateRating" 
    itemscope
    itemtype="http://schema.org/AggregateRating">
    <meta 
      :content="averageScore"
      itemprop="ratingValue" >
    <meta 
      :content="totalReviews"
      itemprop="reviewCount" >
    <div class="yotpo">
      <div class="standalone-bottomline">
        <div class="yotpo-bottomline star-clickable text-right">
          <span class="yotpo-review-stars">
            <span 
              v-for="n in 5"
              :key="n"
              :class="starType(n)"
              class="yotpo-icon" />
          </span><br>
          <span class="text-m">{{ totalReviews }} {{ reviewLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.product-alternatives .yotpo .standalone-bottomline .star-clickable {
  cursor: default;
}
</style>

<script>

export default {
    props: {
        totalReviews: {
            type: Number,
            default: 0
        },
        averageScore: {
            type: Number,
            default: 0
        }
    },

    computed: {
      reviewLabel () {
        return this.totalReviews > 1 ? 'Reviews' : 'Review'
      }
    },

    methods: {
        starType (n) {
            if (this.averageScore + 0.25 > n) {
                return 'yotpo-icon-star'
            }
            if (this.averageScore + 0.75 > n) {
                return 'yotpo-icon-half-star'
            }
            return 'yotpo-icon-empty-star'
        },
    },
}
</script>
